import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';

import { AddVisualArtPerformanceComponent } from '../add-performance/add-performance.component';
import { EditVisualArtPerformanceComponent } from '../edit-performance/edit-performance.component';

import { VisualArtPerformance, DocumentReference, ActivityFormat } from '../../../core/models';
import {
  ActivityFormatService, AgeGroupService, ArrayService, AuthService, VisualArtPerformanceService,
  ChurchService, DatabaseService, DocumentService, FestivalUserService 
} from '../../../core/services';

import { PageClass } from '../../../core/classes/page';

@Component({
  selector: 'app-visual-art-performance-list',
  templateUrl: './performance-list.component.html',
  styleUrls: ['./performance-list.component.less', '../../../core/styles/common.less']
})

export class VisualArtPerformanceListComponent extends PageClass implements OnInit {

  performanceList: VisualArtPerformance[] = [];
  performanceCategoryList: any[] = [];
  filterChurchList: any[] = [];
  filter: any = { church: undefined, itCategory: undefined };

  constructor(
    protected activityFormatService: ActivityFormatService,
    protected visualArtPerformanceService: VisualArtPerformanceService,
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    protected documentService: DocumentService,
    protected modalController: ModalController,
    protected festivalUserService: FestivalUserService,
    protected alertController: AlertController
  ) { 
    super(ageGroupService, arrayService, authService, churchService, databaseService, festivalUserService);
  }

  protected loadData = async () => {
    this.performanceCategoryList = [{name: 'All Categories', value: 'All'}].concat(this.visualArtPerformanceService.getPerformanceCategoryList());

    // Filter.Church
    if (this.currentUser.isAdmin || this.currentUser.isActivityLeader) {
      this.filterChurchList.push({ displayName: 'All Churches', reference: new DocumentReference() });
      this.churchList.forEach(church => this.filterChurchList.push(church));
    } else {
      this.filterChurchList.push(this.currentUser.church);
    }

    this.filter.church = localStorage.getItem(this.filterChurchKey) ? 
        this.filterChurchList.find(c => c.reference.id == localStorage.getItem(this.filterChurchKey)) : 
        this.filterChurchList[0];

    this.filter.itCategory = localStorage.getItem(this.filterITCategoryKey) ? 
        this.performanceCategoryList.find(p => p.value == localStorage.getItem(this.filterITCategoryKey)) : 
        this.performanceCategoryList[0];
    
    this.loadPerformanceList();
  }

  public loadPerformanceList = async () => {

    if (!this.filter.church || !this.filter.itCategory) {
      this.isLoading = false;
      return;
    }
    
    localStorage.setItem(this.filterChurchKey, this.filter.church.reference.id);
    localStorage.setItem(this.filterITCategoryKey, this.filter.itCategory.value);

    this.visualArtPerformanceService.getPerformanceList(this.filter.church, this.filter.itCategory)
      .subscribe(performanceList => {

        this.performanceList = performanceList.sort(this.arrayService.orderByDisplayName);
        this.isLoading = false;
        
    });
  } 

  doRefresh = async (event: any) => {
    await this.loadData();
    event.target.complete();
  }

  public async addPerformance(churchList: DocumentReference[]) {
    (await this.modalController.create({
      component: AddVisualArtPerformanceComponent, componentProps: { churchList }
    })).present();
  }

  public async editPerformance (performance: VisualArtPerformance) {
    (await this.modalController.create({
      component: EditVisualArtPerformanceComponent, componentProps: { performance }
    })).present();
  }

  deletePerformance = (performance: VisualArtPerformance) => {
    
    this.documentService.getDocumentById(this.activityFormatService.collection, performance.format.reference.id).then(format => {
      const creationDueDate = (format as ActivityFormat).creationDueDate;
      if (!this.currentUser.isAdmin && !this.currentUser.isActivityLeader && this.isPastDateString(creationDueDate.toString())) {
        this.showErrorMessage('Cannot Delete Performance',
          `Sorry you cannot delete this performance after ${new Date(creationDueDate).toDateString()}`
        );
      } else {
        this.documentService.deleteDocument(this.visualArtPerformanceService.collection, performance.id);
      }
    });
  }

  showErrorMessage = async (header: string, errorMessage: string) => {
    const alert = await this.alertController.create({
      header: header,
      message: errorMessage,
      buttons: ['OK'],
    });

    alert.onDidDismiss().then(() => { 
    });

    await alert.present();
  }
}
